import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OfbizFormField } from '../ofbiz-form-model';
import { FormGroup } from '@angular/forms';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-ofbiz-file-field-preview',
  templateUrl: './ofbiz-file-field-preview.component.html',
  styleUrls: ['./ofbiz-file-field-preview.component.scss']
})
export class OfbizFileFieldPreviewComponent implements OnChanges{
  @Input() selectedFile: File;
  @Input() fields:OfbizFormField<any>[];
  @Input() form:FormGroup;
  baseUrl:string;
  parsedUrl:any;
  objectInfo:string;
  imageBaseUrl:string;
  imageUrl:string;

  constructor(private configServices:ConfigurationService){
    this.baseUrl = this.configServices.baseUrl;
    this.parsedUrl = new URL(this.baseUrl);
    this.imageBaseUrl = `${this.parsedUrl.protocol}//${this.parsedUrl.hostname}${this.parsedUrl.port ? `:${this.parsedUrl.port}` : ''}`;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["fields"]){
      console.log({FieldChecks:this.fields})
      for(let field of this.fields){
        if(field.name == "objectInfo" || field.name == "image"){
          if(field.name == "objectInfo"){
            console.log({objectInfo:this.form.controls["objectInfo"].value})
            this.objectInfo = this.form.controls["objectInfo"].value;
          }else if(field.name == "image"){
            console.log({image:this.form.controls["image"].value})
            this.objectInfo = this.form.controls["image"].value
          }
          this.imageUrl = this.imageBaseUrl+this.objectInfo;
          console.log({imageUrl:this.imageUrl})
          break;
        }
      }
    }
    if(changes["selectedFile"]){
      // Read file and update preview
      const reader = new FileReader();
      reader.onload = () => {
        this.imageUrl = reader.result as string; // Display new preview
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }
  


}
